import { render } from "./xAllArticles.vue?vue&type=template&id=0139cde2&scoped=true"
import script from "./xAllArticles.vue?vue&type=script&lang=js"
export * from "./xAllArticles.vue?vue&type=script&lang=js"

import "./xAllArticles.vue?vue&type=style&index=0&id=0139cde2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0139cde2"]])

export default __exports__